import "core-js/modules/es.array.for-each";
import "core-js/modules/es.array.index-of";
import "core-js/modules/es.object.to-string";
import "core-js/modules/web.dom-collections.for-each";
import _objectSpread from "D:/work/admin/datacenter_web/node_modules/@babel/runtime/helpers/esm/objectSpread2";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { mapState } from 'vuex';
import { serchSelect, tabulation, gmToolNewPage, gmTool } from "@/mixins/index";
import { rechargeDailyLoginTaskCurrency, rechargeDailyLoginTask } from "@/api/dataAll/userSegmentationGrowth";
import { serverList } from "@/api/gmtool/packageCode";
import { serverList as hdServerList } from "@/api/gmtool/packageCode";
import { serverList as yjServerList } from "@/api/gmToolNew/gmToolNew";
export default {
  name: "activeUserLoginProgress",
  mixins: [serchSelect, tabulation, gmToolNewPage, gmTool],
  data: function data() {
    return {
      tableData: [],
      deviceList: [{
        label: this.$t('newAccountLabel'),
        id: "user"
      }],
      paramsData: {
        dimension_kind: "user"
      },
      tableList: [],
      serverList: []
    };
  },
  computed: _objectSpread({}, mapState("d2admin", {
    severlist: function severlist(state) {
      return state.user.GMauthority;
    }
  })),
  created: function created() {
    this.searchData.env_id = this.szgmEnv.length ? this.szgmEnv[0].id : '';

    if (this.rawData.game_mark.indexOf('yjfm') == -1) {
      this.getServer();
    }
  },
  methods: {
    levelChange: function levelChange(e) {
      if (!e) {
        this.paramsData.recharge_levels = '';
      }
    },
    getServer: function getServer() {
      var _this = this;

      this.paramsData.server_id = '';
      serverList({
        is_prod: this.paramsData.is_prod,
        page_size: ''
      }).then(function (res) {
        if (res.status == 200) {
          _this.serverList = res.data;
        }
      });
    },
    searchClick: function searchClick() {
      var _this2 = this;

      this.tableList = [];
      this.tableData = [];

      if (this.value2.length > 0) {
        this.searchData.starttime = this.value2[0];
        this.searchData.endtime = this.value2[1];
      }

      if (!this.paramsData.dimension_kind) {
        this.$message.error(this.$t('pleaseSelectNewDeviceOrAccount'));
        return;
      }

      if (this.levelItem == '1' && !this.paramsData.recharge_levels) {
        this.$message.error(this.$t('pleaseInputLevel'));
        return;
      }

      if (/，/.test(this.paramsData.recharge_levels)) {
        this.$message.error(this.$t('pleaseInputEnglishComma'));
        return;
      }

      this.reqLoading = true;
      var params = {
        dimension_kind: this.paramsData.dimension_kind,
        game_id: this.searchData.game_id,
        special_product_id: this.searchData.special_product_id,
        starttime: this.searchData.starttime,
        endtime: this.searchData.endtime,
        server_id: this.paramsData.server_id,
        recharge_levels: this.paramsData.recharge_levels
      }; //判断是否有货币

      var searchCurrency = this.$store.state.d2admin.serchSelect.searchCurrency;
      var reqFn = searchCurrency.length ? rechargeDailyLoginTaskCurrency : rechargeDailyLoginTask;
      reqFn(params).then(function (res) {
        if (res.code == 200) {
          (function () {
            var data = res.data;
            var level_map = res.level_map;
            var statusArr = [];
            var tableItem = []; //处理表格数据

            for (var m in level_map) {
              _this2.tableData.push({});

              tableItem.push({});
            }

            for (var i in data) {
              for (var j in data[i]) {
                statusArr.push(j);
              }

              break;
            }

            for (var _i in data) {
              _this2.tableList.push({
                label: _i,
                prop: _i,
                list: []
              });
            }

            _this2.tableList.forEach(function (Aitem) {
              statusArr.forEach(function (item, idx) {
                if (idx == 0) {
                  Aitem.list.push({
                    label: _this2.$t('loginCountLabel'),
                    prop: Aitem.label + item + "login_count_level"
                  }, {
                    label: _this2.$t('passLevel', {
                      level: item
                    }),
                    prop: Aitem.label + item + "task_count_level"
                  }, {
                    label: _this2.$t('passCount', {
                      level: item
                    }),
                    prop: Aitem.label + item + "pass_count_level"
                  }, {
                    label: _this2.$t('avgTaskNumLevel', {
                      level: item
                    }),
                    prop: Aitem.label + item + "avg_task_num_level"
                  }, {
                    label: _this2.$t('avgDurationLevel', {
                      level: item
                    }),
                    prop: Aitem.label + item + "avg_duration_level"
                  });
                } else {
                  Aitem.list.push({
                    label: _this2.$t('passLevel', {
                      level: item
                    }),
                    prop: Aitem.label + item + "task_count_level"
                  }, {
                    label: _this2.$t('passCount', {
                      level: item
                    }),
                    prop: Aitem.label + item + "pass_count_level"
                  }, {
                    label: _this2.$t('avgTaskNumLevel', {
                      level: item
                    }),
                    prop: Aitem.label + item + "avg_task_num_level"
                  }, {
                    label: _this2.$t('avgDurationLevel', {
                      level: item
                    }),
                    prop: Aitem.label + item + "avg_duration_level"
                  });
                }
              });
            });

            var _loop = function _loop(_i2) {
              //数据处理
              _this2.tableData.forEach(function (item, index) {
                statusArr.forEach(function (items, idx) {
                  _this2.tableData[index][_i2 + "".concat(statusArr[idx], "task_count_level")] = data[_i2][statusArr[idx]]["task_count_level_" + (index + 1)];
                  _this2.tableData[index][_i2 + "".concat(statusArr[idx], "pass_count_level")] = data[_i2][statusArr[idx]]["pass_count_level_" + (index + 1)];
                  _this2.tableData[index][_i2 + "".concat(statusArr[idx], "avg_task_num_level")] = data[_i2][statusArr[idx]]["avg_task_num_level_" + (index + 1)];
                  _this2.tableData[index][_i2 + "".concat(statusArr[idx], "avg_duration_level")] = data[_i2][statusArr[idx]]["avg_duration_level_" + (index + 1)];

                  if (idx == 0) {
                    _this2.tableData[index][_i2 + "".concat(statusArr[idx], "login_count_level")] = data[_i2][statusArr[idx]]["login_count_level_" + (index + 1)];
                  }
                });
              });
            };

            for (var _i2 in data) {
              _loop(_i2);
            }

            _this2.tableList.unshift({
              label: '',
              list: [{
                label: _this2.$t('payAmount'),
                prop: 'level_amount',
                desc: _this2.$t('payAmountRangeDesc')
              }]
            });

            tableItem.forEach(function (items, idx) {
              _this2.tableData[idx]["level_amount"] = level_map["level_".concat(idx + 1)];
            });
          })();
        }
      }).finally(function () {
        _this2.reqLoading = false;
      });
    },
    exportdata: function exportdata() {
      var columns = [];
      var d = {};
      this.tableList.forEach(function (item, index) {
        item.list.forEach(function (items, indexs) {
          columns.push({
            label: indexs == 0 ? item.label : '',
            prop: items.prop
          });
          d[items.prop] = items.label;
        });
      });
      var data = JSON.parse(JSON.stringify(this.tableData));
      data.unshift(d);
      this.$export.excel({
        columns: columns,
        data: data,
        title: this.$route.meta.title
      });
    }
  }
};